module.exports = __webpack_public_path__ + "img/logo_u1992-20.96ed7327.svg";